import * as mutationTypes from '@/store/mutation-types.js'
import stringOperations from '@/mixins/string-operations'
import dateOperations from '@/mixins/date-operations'
import kalender from '@/components/utils/kalender/kalender.vue'
import icons from '@/mixins/icons.js'

import * as globalMutationTypes from '@/store/mutation-types.js'

import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import mmItems from '@/mixins/main-menu-items.js'
import basicOperations from '@/mixins/basic-operations.js'

import ValidationService from "@/services/validation.service.js";
const validationService = new ValidationService();

export default {
  name: 'MijnGebruikerWachtwoordWijzigen',

  mixins: [stringOperations, dateOperations, icons, mmItems, basicOperations],

  components: {
    kalender
  },

  data() {
    return {
      userdata: {},
      debugging: this.$store.state.debugging,
      PWMin8: false,
      PWSpecialChars: false,
      duplicatePassword: '',
      passwordsInfo: [],
      passwordFieldType: 'password',
      schermen: [],
      selectedScherm: null,
      isOuder: false,
      isStudent: false,
      isLeerkracht: false,
      returnLink: encodeURI(JSON.stringify({
        "linkreturn": true
      })),
      url: window.location.href.split('/Agenda')[0],
      serverLocation: null,
      isAndroidOrIOS: this._isAndroidOrIOS(),
      //geboortedatum: this._formatDateSQL(new Date()),
      mySchoolwareAccount: {},
      mySchoolwareAccountBACKUP: {},
      hideButton: false,
      passwordWijzigen: true
    }
  },

  computed: {
    nameOfUser() {
      return this._capitalizeFirstLetters(
        this.$store.state.userInfo.loggedInUserInformation.UserData.name
      )
    },
    matchingPassword() {
      if (this.mySchoolwareAccount.NewPaswoord !== "" && this.duplicatePassword !== "") {
        return this.mySchoolwareAccount.NewPaswoord === this.duplicatePassword;
      } else {
        return false;
      }
    }
  },

  mounted: function () {

    this.duplicatePassword = ''

    this.userdata = this.$store.state.userInfo.loggedInUserInformation.UserData
    console.log('mijn-gebruiker mounted')

    if (this.$store.state.api === '') {
      this.$store.dispatch('apiCheck', {
        dezeDit: this,
        succesCallback: this.vervolgMounted
      })
    } else {
      this.vervolgMounted()
    }

  },

  methods: {

    successCallbackGetMySchoolwareAccount: function () {
      console.log('successCallbackGetMySchoolwareAccount')

      var links = ''
      if (this.isAndroidOrIOS) {
        links = 'menu'
      } else {
        // this.$store.commit(mutationTypes.SET_SHOW_TOP_LOGO, true)
      }
      this.$store.commit(mutationTypes.SET_MENUBAR_ITEMS, {
        left: 'links',
        title: 'Welkom ' + this.mySchoolwareAccount.Voornaam + ' ' + this.mySchoolwareAccount.Achternaam + ', gelieve je wachtwoord te wijzigen ',
        right: []
      })
    },

    vervolgMounted: function () {
      this.isLeerkracht = this.$store.state.userInfo.isLeerkracht
      this.isOuder = this.$store.state.userInfo.isOuder
      this.isStudent = this.$store.state.userInfo.isStudent
      this.PWMin8 = this.$store.state.api.PWMin8
      this.PWSpecialChars = this.$store.state.api.PWSpecialChars

      this.$store.dispatch('getMySchoolwareAccount', this)
    },

    editPassword() {
      console.log('oude request oproepen')
      this.resetToInitialData()
      this.passwordWijzigen = true
    },

    changePasswordConfirmation() {
      console.log('changePasswordConfirmation')
      this.$store.dispatch('putMySchoolwareAccount', this)
    },

    successCallbackPutMySchoolwareAccount() {
      console.log('successCallbackPutMySchoolwareAccount')
      this.hideButton = true
      this.$store.state.userInfo.loggedInUserInformation.UserData.veranderpaswoord = false
      if (this.isAndroidOrIOS) {
        this.$store.commit(globalMutationTypes.SHOW_MESSAGE, ['Wachtwoord wijzigen voltooid.'])
        var self = this
        setTimeout(function () {
          /*if (self.$store.state.userInfo.isOuder) {
            self.$router.push('kids')
          } else {
            self.$router.push('landing-page')
          }*/
          //self.$router.push('login')
          self.$router.go(-1) // navragen muhammet 'login' callback
        }, 1000, self)
      } else {
        this.$store.commit(globalMutationTypes.SHOW_MESSAGE, 'Wachtwoord wijzigen voltooid.')
        setTimeout(function () {
          sessionStorage.setItem("VUE_DO_NOT_OVERWRITE_SESSION", "true")
          // window.location.href = window.location.href.split('/vue/')[0] + '/Agenda.html'
          self.$router.push('/')
        }, 1000)

      }

    },

    passwordChanged: function () {
      this.passwordsInfo = this._passwordValidation(this.mySchoolwareAccount.NewPaswoord, this.duplicatePassword, this.PWMin8, this.PWSpecialChars)
    },

    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },

  }
}
